import {
  TABLE_SORT_DESC,
  PRODUCTS,
  BUBBLE_CHART_COLOR,
  STATE_CODE_NAME,
  DOUGHNUT_TYPE,
  NOT_AVAILABLE,
} from "../../utils/Constants.tsx";
import {
  getValueForMap,
  numberFormatWithoutCurrency,
  sortListItems,
} from "../../utils/Util.tsx";
import {
  CROP_CHART,
  getGridChartOption,
  PERIL_CHART,
  getStateChartOption,
  TARGET_CHART,
  getAmountDisbursedOptions,
  STATE_CHART,
  getProductChart,
} from "./NocChartOption.ts";

const getTitle = (levelTwo, type) => {
  if (levelTwo === "Policy Count" && type === "product") {
    return "Product contribution based on policy count";
  } else if (levelTwo === "Policy Count" && type === "grid") {
    return "Policies count in top grid";
  } else if (levelTwo === "Policy Count" && type === "state") {
    return "Policies count in top states";
  } else if (levelTwo === "Policy Count" && type === "crop") {
    return "Top insured crops based on policy count";
  } else if (levelTwo === "Premium" && type === "product") {
    return "Product contribution based on premium(₹)";
  } else if (levelTwo === "Premium" && type === "grid") {
    return "Premium(₹) in top grid";
  } else if (levelTwo === "Premium" && type === "state") {
    return "Premium(₹) in top states";
  } else if (levelTwo === "Premium" && type === "crop") {
    return "Top crops premium(₹) analysis";
  } else if (levelTwo === "Customer Count" && type === "product") {
    return "Product contribution based on customer count";
  } else if (levelTwo === "Customer Count" && type === "grid") {
    return "Customer count in top grid";
  } else if (levelTwo === "Customer Count" && type === "state") {
    return "Customer count in top states";
  } else if (levelTwo === "Customer Count" && type === "crop") {
    return "Top crops based on customer count";
  } else if (levelTwo === "Insured Area" && type === "product") {
    return "Product contribution based on Insured Area";
  } else if (levelTwo === "Insured Area" && type === "grid") {
    return "Insured Area in top grid";
  } else if (levelTwo === "Insured Area" && type === "state") {
    return "Insured Area in top states";
  } else if (levelTwo === "Insured Area" && type === "crop") {
    return "Top insured crops based on Insured Area";
  } else if (levelTwo === "Sum Insured" && type === "product") {
    return "Product contribution based on Sum Insured";
  } else if (levelTwo === "Sum Insured" && type === "grid") {
    return "Sum Insured in top grid";
  } else if (levelTwo === "Sum Insured" && type === "state") {
    return "Sum Insured in top states";
  } else if (levelTwo === "Sum Insured" && type === "crop") {
    return "Top insured crops based on Sum Insured";
  } else if (levelTwo === "Total Claim Count" && type === "product") {
    return "Product wise claims";
  } else if (levelTwo === "Total Claim Count" && type === "peril") {
    return "Perils wise claims";
  } else if (levelTwo === "Total Claim Count" && type === "state") {
    return "States wise most claims";
  } else if (levelTwo === "Total Claim Count" && type === "crop") {
    return "Crop with most claims";
  } else if (levelTwo === "Amount Disbursed" && type === "product") {
    return "Product wise pending and processed claims";
  } else if (levelTwo === "Amount Disbursed" && type === "grid") {
    return "Peril wise pending & Potential";
  } else if (levelTwo === "Amount Disbursed" && type === "state") {
    return "State with high potential and Disbursed Claim Amount";
  } else if (levelTwo === "Amount Disbursed" && type === "crop") {
    return "Crop wise Potential Amount";
  } else if (levelTwo === "Pending Claims" && type === "product") {
    return "Product wise Pending and Processed claims";
  } else if (levelTwo === "Pending Claims" && type === "grid") {
    return "Peril wise claim Amount Disbursed & Potential";
  } else if (levelTwo === "Pending Claims" && type === "state") {
    return "State with high potential and Disbursed Claim Amount";
  } else if (levelTwo === "Pending Claims" && type === "crop") {
    return "Crop wise Potential Amount";
  } else if (levelTwo === "Loss Ratio(Claim/Premium)" && type === "product") {
    return "Loss ratio(Claims/Premium) per product";
  } else if (levelTwo === "Loss Ratio(Claim/Premium)" && type === "grid") {
    return "Loss ratio(Claims/Premium) by grid";
  } else if (levelTwo === "Loss Ratio(Claim/Premium)" && type === "state") {
    return "States with most loss ratio";
  } else if (levelTwo === "Loss Ratio(Claim/Premium)" && type === "crop") {
    return "Crop with most loss ratio";
  } else if (levelTwo === "POSPm Count" && type === "grid") {
    return "POSPm count by state";
  } else if (levelTwo === "POSP Count" && type === "grid") {
    return "POSP count by state";
  } else if (levelTwo === "Target" && type === "Target") {
    return "Targets v/s achieved at state level";
  } else {
    return "--";
  }
};

const getClaimCountPerilWise = (data) => {
  try {
    const perilData = {};
    data.forEach((item) => {
      const claimDetails = item.claims?.claim_details || [];
      claimDetails.forEach((claim) => {
        const peril = claim.peril;
        if (!perilData[peril]) {
          perilData[peril] = 0;
        }
        perilData[peril] += 1;
      });
    });
    const result = Object.entries(perilData).map(([id, total]: any) => ({
      id,
      total,
    }));
    return result;
  } catch (e) {}
  return null;
};
/**
 * This is method used to sum ValueName on the basis of keyName
 * @param data
 * @param keyName
 * @param ValueName
 * @returns
 */
const getTotalValueWithKey = (data, keyName, ValueName) => {
  try {
    const result = data?.reduce((acc, item) => {
      acc[item[keyName]] =
        (acc[item[keyName]] || 0) + Number(item[ValueName] || 0);
      return acc;
    }, {});

    if (result) {
      const resultObject = Object.entries(result).map(([id, total]) => ({
        id: id,
        total,
      }));
      return resultObject;
    }
  } catch (e) {}
  return null;
};

const getPOSPTargets = (data) => {
  try {
    const result = {};
    data.forEach((item) => {
      const sid = item.sid;
      const achieved = parseFloat(item?.achieved_percentage || 0);
      const target = parseFloat(item?.target_value || 0);

      if (!result[sid]) {
        result[sid] = {
          achieved: 0,
          target: 0,
        };
      }
      result[sid].achieved += (target * achieved) / 100;
      result[sid].target += target;
    });
    if (result) {
      const resultArray = Object.entries(result).map(([key, value]: any) => ({
        id: Number(key),
        achieved: value?.achieved,
        target: value?.target,
      }));
      return resultArray;
    }
  } catch (e) {}
  return null;
};

const scaleRadius = (value, minVal, maxVal, minR = 20, maxR = 40) => {
  return minR + ((value - minVal) * (maxR - minR)) / (maxVal - minVal);
};

const getCropWithPolicyCustomerCount = (data) => {
  try {
    const cropCustomerCount = {};

    data.forEach((entry) => {
      entry?.crop_names.forEach((crop) => {
        if (!cropCustomerCount[crop]) {
          cropCustomerCount[crop] = 0;
        }
        cropCustomerCount[crop] += entry.customer_count;
      });
    });
    if (cropCustomerCount) {
      const resultObject = Object.entries(cropCustomerCount).map(
        ([id, total]) => ({
          id: id,
          total,
        })
      );
      return resultObject;
    }
  } catch (e) {}
  return null;
};
const sumPayoutAmountonWithId = (data, id) => {
  try {
    const payoutWithId = {};
    data.forEach((entry) => {
      entry?.payout_amounts?.forEach((payout) => {
        if (!payoutWithId[entry[id]]) {
          payoutWithId[entry[id]] = 0;
        }
        payoutWithId[entry[id]] += payout;
      });
    });

    if (payoutWithId) {
      const resultObject = Object.entries(payoutWithId).map(([id, total]) => ({
        id: id,
        total,
      }));
      return resultObject;
    }
  } catch (e) {}
  return null;
};
const CenterTextPlugin = (text: string) => ({
  id: "centerText",
  beforeDraw: (chart) => {
    const { width, height, ctx } = chart;

    ctx.save(); // Calculate font size based on chart size

    const fontSize = Math.min(width, height) / 18;
    ctx.font = `${fontSize}px sans-serif`;
    ctx.textBaseline = "middle";
    ctx.textAlign = "center";

    const centerX = width / 2;
    const centerY = height / 2 - 10;

    ctx.fillStyle = "#00000080"; // Text color
    ctx.fillText(text, centerX, centerY);
    ctx.restore();
  },
});
export const getProductData = (
  viewData: any,
  levelOne: string,
  levelTwo: string
) => {
  let result;
  let centerSubText = "";
  if (levelTwo === "Policy Count") {
    result = getTotalValueWithKey(viewData, "productid", "policy_count");
    centerSubText = "Total Policies";
  } else if (levelTwo === "Premium") {
    result = getTotalValueWithKey(viewData, "productid", "premium");
    centerSubText = "Total Premium";
  } else if (levelTwo === "Insured Area") {
    centerSubText = "Total Insured Area";
    result = getTotalValueWithKey(viewData, "productid", "area");
  } else if (levelTwo === "Sum Insured") {
    centerSubText = "Total Sum Insured";
    result = getTotalValueWithKey(viewData, "productid", "suminsured");
  } else if (levelTwo === "Customer Count") {
    result = getTotalValueWithKey(viewData, "productid", "customer_count");
    centerSubText = "Total Customer";
  } else if (levelTwo === "Total Claim Count") {
    result = getTotalValueWithKey(viewData, "productid", "claims_count");
    centerSubText = "Total Claim";
  } else if (levelTwo === "Loss Ratio(Claim/Premium)") {
    result = getTotalValueWithKey(viewData, "productid", "loss_ratio");
    centerSubText = "Total Loss Ratio";
  } else if (levelTwo === "Target") {
    result = getTotalValueWithKey(viewData, "productid", "target_value");
    centerSubText = "Total POSP";
  } else if (levelTwo === "Amount Disbursed") {
    result = getAmountDisbursedData(viewData, "productid", "claims_count");
    centerSubText = "Total Claim";
  } else if (levelTwo === "Pending Claims") {
    result = getAmountDisbursedData(viewData, "productid", "claims_count");
    centerSubText = "Total Claim";
  }
  if (result?.length) {
    const labels: any = [];
    const datasets: any[] = [];
    const pendingClaims: any[] = [];
    const processedClaims: any[] = [];
    let sum = 0;
     let sum2 = 0;
    result?.forEach((item) => {
      labels.push(PRODUCTS[item.id]);
      if (levelTwo === "Amount Disbursed" || levelTwo === "Pending Claims") {
        pendingClaims.push(Number(item?.total-item.processed));
        sum += Number(item?.total || 0);
        processedClaims.push(item?.processed);
         sum2 += Number(item?.processed || 0);
      } else {
        datasets.push(item?.total);
        sum += Number(item?.total || 0);
      }
      
    });
    if (levelTwo === "Amount Disbursed") {
      const data = {
        labels: labels,
        datasets: [
          {
            label: "Processed Claims",
            backgroundColor: "#A3A5FE",
            borderColor: "#FFA07A",
            borderWidth: 1,
            hoverBackgroundColor: "#FF8C69",
            hoverBorderColor: "#FF8C69",
            data: processedClaims,
            barThickness: 20, // Example data for processed claims
            categoryPercentage: 0.2,
            barPercentage: 0.2,
          },
          {
            label: "Pending Claims",
            backgroundColor: "#FFAC6A",
            borderColor: "#8A9BFF",
            borderWidth: 1,
            hoverBackgroundColor: "#6F7DFF",
            hoverBorderColor: "#6F7DFF",
            data: pendingClaims, // Example data for total claims
            barThickness: 20,
            categoryPercentage: 0.5,
            barPercentage: 0.6,
          },
        ],
      };
      return {
        data,
        options: getProductChart(levelTwo),
        //plugins: [CenterTextPlugin(sum + " " + centerText)],
        chartTitle: getTitle(levelTwo, "product"),
      };
    } else if (levelTwo === "Pending Claims") {
      const processedData = {
        labels: labels,
        datasets: [
          {
            data: processedClaims,
            backgroundColor: ["#FFAC6A", "#3498D1", "#F182C1"],
            borderWidth: 1,
          },
        ],
      };
      const pendingData = {
        labels: labels,
        datasets: [
          {
            data: pendingClaims,
            backgroundColor: ["#FFAC6A", "#3498D1", "#F182C1"],
            borderWidth: 1,
          },
        ],
      };

      let centerText;
      let centerText2;
      centerText = numberFormatWithoutCurrency(sum, 0);
      centerText2 = numberFormatWithoutCurrency(sum2, 0);

      return {
        data: [processedData, pendingData],
        doughnutType: DOUGHNUT_TYPE.double,
        options: getProductChart(levelTwo),
        centerText,
        centerText2,
        centerSubText,
        //plugins: [CenterTextPlugin(sum + " " + centerText)],
        chartTitle: getTitle(levelTwo, "product"),
      };
    } else {
      const data = {
        labels: labels,
        datasets: [
          {
            data: datasets,
            backgroundColor: ["#FFAC6A", "#3498D1", "#F182C1"],
            borderWidth: 1,
          },
        ],
      };

      let centerText;
      if (levelTwo === "Premium") {
        centerText = numberFormatWithoutCurrency(sum);
      } else if (levelTwo === "Loss Ratio(Claim/Premium)") {
        centerText = numberFormatWithoutCurrency(sum);
      } else if (levelTwo === "Target") {
        centerText = numberFormatWithoutCurrency(sum);
      } else {
        centerText = numberFormatWithoutCurrency(sum, 0);
      }
      return {
        data,
        options: getProductChart(levelTwo),
        doughnutType: DOUGHNUT_TYPE.single,
        centerText,
        centerSubText,
        //plugins: [CenterTextPlugin(sum + " " + centerText)],
        chartTitle: getTitle(levelTwo, "product"),
      };
    }
  }
  return null;
};
export const getPendingClaims = (data, key) => {
  try {
    const totalAmounts = {};
    const processedAmounts = {};
    const rejectedAmounts = {};
    const pendingAmounts = {};
    const processedClaims: any = [];
    const rejectedClaims: any = [];
    const pendingClaims: any = [];
    data.forEach((item) => {
      const claimDetails = item.claims?.claim_details || [];
      claimDetails.forEach((claim) => {
        const keyItem = item[key];
        if (!keyItem) return;
        // Aggregate total payout
        totalAmounts[keyItem] =
          (totalAmounts[keyItem] || 0) + Number(claim?.payout_amount || 0);

        // Track processed claims
        if (["Success", "Processed"].includes(claim.disbursement_status)) {
          const enrichedClaim: any = { ...claim, sid: item.sid };
          processedClaims.push(enrichedClaim);

          // Aggregate processed payout
          const processedKey = enrichedClaim[key];
          processedAmounts[processedKey] =
            (processedAmounts[processedKey] || 0) +
            Number(enrichedClaim.payout_amount || 0);
        }
        if (["Failed", "Pending", null].includes(claim.disbursement_status)) {
          const enrichedClaim: any = { ...claim, sid: item.sid };
          pendingClaims.push(enrichedClaim);

          // Aggregate processed payout
          const processedKey = enrichedClaim[key];
          pendingAmounts[processedKey] =
            (pendingAmounts[processedKey] || 0) +
            Number(enrichedClaim.payout_amount || 0);
        }

        if (["Rejected"].includes(claim.disbursement_status)) {
          const enrichedClaim: any = { ...claim, sid: item.sid };
          rejectedClaims.push(enrichedClaim);

          // Aggregate processed payout
          const processedKey = enrichedClaim[key];
          rejectedAmounts[processedKey] =
            (rejectedAmounts[processedKey] || 0) +
            Number(enrichedClaim.payout_amount || 0);
        }
      });
    });
    // Format final result
    return Object.entries(totalAmounts).map(([id, total]) => ({
      id,
      total: Number(Number(total).toFixed(2)),
      processed: Number(Number(processedAmounts[id] || 0).toFixed(2)),
      rejected: Number(Number(rejectedAmounts[id] || 0).toFixed(2)),
      pending: Number(Number(pendingAmounts[id] || 0).toFixed(2)),
    }));
  } catch (e) {}
  return null;
};
export const getStateWiseData = (
  viewData: any,
  levelOne: string,
  levelTwo: string
) => {
  try {
    // const result = getTotalPremiumKey(viewData, "sid");
    let result;
    if (levelTwo === "Policy Count") {
      result = getTotalValueWithKey(viewData, "sid", "policy_count");
    } else if (levelTwo === "Premium") {
      result = getTotalValueWithKey(viewData, "sid", "premium");
    } else if (levelTwo === "Insured Area") {
      result = getTotalValueWithKey(viewData, "sid", "area");
    } else if (levelTwo === "Sum Insured") {
      result = getTotalValueWithKey(viewData, "sid", "suminsured");
    } else if (levelTwo === "Customer Count") {
      result = getTotalValueWithKey(viewData, "sid", "customer_count");
    } else if (levelTwo === "Total Claim Count") {
      result = getTotalValueWithKey(viewData, "sid", "claims_count");
    } else if (levelTwo === "Loss Ratio(Claim/Premium)") {
      result = getTotalValueWithKey(viewData, "sid", "loss_ratio");
    } else if (levelTwo === "Target") {
      result = getTotalValueWithKey(viewData, "sid", "target_value");
    } else if (levelTwo === "POSPM-STATE") {
      result = getTotalValueWithKey(viewData, "sid", "count");
    } else if (levelTwo === "Amount Disbursed") {
      result = getAmountDisburse(viewData, "sid");
    } else if (levelTwo === "Pending Claims") {
      result = getPendingClaims(viewData, "sid");
    }
    if (result?.length) {
      if (levelTwo === "Pending Claims") {
        const sortedArray = sortListItems(result, "total", TABLE_SORT_DESC);        
        const topEight = sortedArray.filter((item)=>item.total !== 0)        
        const labels: any[] = [];
        const processed: number[] = [];
        const pending: number[] = [];
        const rejected: number[] = [];
        topEight.forEach((element) => {
          labels.push(STATE_CODE_NAME[String(element.id)]?.code || NOT_AVAILABLE);
          processed.push(element.processed.toFixed(2));
          pending.push(element.pending.toFixed(2));
          rejected.push(element.rejected.toFixed(2));
        });
        const data = {
          labels: labels,
          datasets: [
            {
              label: "processed",
              data: processed,
              backgroundColor: "#16C999",
              borderRadius: 4,
            },
            {
              label: "Pending",
              data: pending,
              backgroundColor: "#929BFF",
              borderRadius: 4,
            },
            {
              label: "Rejected",
              data: rejected,
              backgroundColor: "#FFAC6A",
              borderRadius: 4,
            },
          ],
        };

        return {
          data,
          options: STATE_CHART,
          chartTitle: getTitle(levelTwo, "state"),
        };
      } else if (levelTwo === "Amount Disbursed") {
        const sortedArray = sortListItems(result, "total", TABLE_SORT_DESC);
        const topEight = sortedArray.slice(0, 7);
        const labels: any[] = [];
        const dataTotal: number[] = [];
        const potential: number[] = [];
        topEight.forEach((element) => {
          labels.push(STATE_CODE_NAME[String(element.id)]?.code || NOT_AVAILABLE);
          dataTotal.push(element.processed.toFixed(2));
          const data: any = (
            Number(element.total) - Number(element.processed)
          ).toFixed();
          potential.push(data);
        });
        const data = {
          labels: labels,
          datasets: [
            {
              label: "Amount Disbursed",
              data: dataTotal,
              backgroundColor: "#16C999",
              borderRadius: 4,
            },
            {
              label: "Potential",
              data: potential,
              backgroundColor: "#52DBB6",
              borderRadius: 4,
            },
          ],
        };

        return {
          data,
          options: getAmountDisbursedOptions(levelTwo, "states"),
          chartTitle: getTitle(levelTwo, "state"),
        };
      } else {
        const sortedArray = sortListItems(result, "total", TABLE_SORT_DESC);
        const topEight = sortedArray.slice(0, 7);
        const labels: any[] = [];
        const dataTotal: number[] = [];
        topEight.forEach((element) => {
          labels.push(STATE_CODE_NAME[String(element.id)]?.code || NOT_AVAILABLE);
          dataTotal.push(element.total);
        });
        const data = {
          labels: labels,
          datasets: [
            {
              data: dataTotal,
              backgroundColor:
                levelTwo === "POSPM-STATE" ? "#666CFF4D" : "#70C8B180",
              borderColor: levelTwo === "POSPM-STATE" ? "#666CFF" : "#70C8B1",
              borderWidth: 1,
              borderRadius: {
                topLeft: 4,
                topRight: 4,
                bottomRight: 4,
                bottomLeft: 4,
              },
            },
          ],
        };

        return {
          data,
          options:
            levelTwo === "POSPM-STATE"
              ? getGridChartOption("States", "POSP Count")
              : getStateChartOption("States", levelTwo),
          chartTitle: getTitle(levelTwo, "state"),
        };
      }
    }
  } catch (e) {
  }
  return null;
};

export const getPOSPTargetAndAchieved = (
  viewData: any,
  levelOne: string,
  levelTwo: string
) => {
  try {
    const result = getPOSPTargets(viewData);
    if (result) {
      const sortedArray = sortListItems(result, "target", TABLE_SORT_DESC);
      const topData = sortedArray.slice(0, 12);
      const remainingData = sortedArray.slice(12, sortedArray.length);

      let otherSumAchieved = 0;
      let otherSumTarget = 0;
      let otherText = "Other";

      remainingData.forEach((item) => {
        otherSumAchieved += item.achieved;
        otherSumTarget += item.target;
      });
      const labels: any[] = [];
      const dataAchieved: number[] = [];
      const dataTarget: number[] = [];
      topData.forEach((element) => {
        labels.push(STATE_CODE_NAME[String(element?.id)]?.code || NOT_AVAILABLE);
        dataAchieved.push(element.achieved);
        dataTarget.push(element.target);
      });
      if (otherSumTarget) {
        labels.push(otherText);
        dataAchieved.push(otherSumAchieved);
        dataTarget.push(otherSumTarget);
      }

      const data = {
        labels: labels,
        responsive: true,
        offset: true,
        datasets: [
          {
            label: "Achieved",
            backgroundColor: levelTwo === "Target" ? "#70C8B1" : "#96D9FE",
            borderWidth: 1,
            borderColor: levelTwo === "Target" ? "#70C8B1" : "#96D9FE",
            borderRadius: {
              topLeft: 4,
              topRight: 4,
              bottomRight: 4,
              bottomLeft: 4,
            },
            barThickness: 40,
            categoryPercentage: 1,
            pointStyle: "triangle",
            data: dataAchieved,
          },
          {
            label: "Target",
            pointStyle: "rectRounded",
            backgroundColor: levelTwo === "Target" ? "#70C8B1AD" : "#96D9FE",
            borderWidth: 1,
            borderColor: levelTwo === "Target" ? "#70C8B1" : "#96D9FE",
            borderRadius: {
              topLeft: 4,
              topRight: 4,
              bottomRight: 4,
              bottomLeft: 4,
            },
            barThickness: 40,
            categoryPercentage: 1,
            data: dataTarget,
          },
        ],
      };

      return {
        data,
        options: TARGET_CHART,
        chartTitle: getTitle(levelTwo, "Target"),
      };
    }
  } catch (e) {}
  return null;
};
export const getAmountDisbursedData = (data, keyName, valueName) => {
  try {
    const result = data?.reduce((acc, item) => {
      acc[item[keyName]] =
        (acc[item[keyName]] || 0) + Number(item[valueName] || 0);
      return acc;
    }, {});
    // Calculate the processed claims count based on keyName

    const processedClaimsCount = data?.reduce((acc, item) => {
      const processedClaims = item.claims.claim_details.filter((a) => {
        return (
          a.disbursement_status === "Success" ||
          a.disbursement_status === "Processed"
        );
      });
      acc[item[keyName]] = (acc[item[keyName]] || 0) + processedClaims.length;
      return acc;
    }, {});

    const mergedResult = Object.entries(result).map(([id, total]) => ({
      id: id,
      total,
      processed: processedClaimsCount[id] || 0,
    }));

    return mergedResult;
  } catch (e) {
  }
  return null;
};
const getAmountDisburse = (data, key) => {
  try {
    const totalAmounts = {};
    const processedAmounts = {};
    const processedClaims: any = [];
    data.forEach((item) => {
      const claimDetails = item.claims?.claim_details || [];
      claimDetails.forEach((claim) => {
        const keyItem = key === "sid" ? item[key] : claim[key];
        if (!keyItem) return;
        // Aggregate total payout
        totalAmounts[keyItem] =
          (totalAmounts[keyItem] || 0) + Number(claim?.payout_amount || 0);

        // Track processed claims
        if (["Success", "Processed"].includes(claim.disbursement_status)) {
          const enrichedClaim: any = { ...claim, sid: item.sid };
          processedClaims.push(enrichedClaim);

          // Aggregate processed payout
          const processedKey = enrichedClaim[key];
          processedAmounts[processedKey] =
            (processedAmounts[processedKey] || 0) +
            Number(enrichedClaim.payout_amount || 0);
        }
      });
    });

    // Format final result
    return Object.entries(totalAmounts).map(([id, total]) => ({
      id,
      total: Number(Number(total).toFixed(2)),
      processed: Number(processedAmounts[id] || 0),
    }));
  } catch (e) {
    return null;
  }
};

export const getGridWiseData = (
  viewData: any,
  levelOne: string,
  levelTwo: string
) => {
  try {
    let key = "";
    if (levelTwo === "Policy Count") {
      key = "policy_count";
    } else if (levelTwo === "Premium") {
      key = "premium";
    } else if (levelTwo === "Customer Count") {
      key = "customer_count";
    } else if (levelTwo === "Insured Area") {
      key = "area";
    } else if (levelTwo === "Sum Insured") {
      key = "suminsured";
    } else if (levelTwo === "Total Claim Count") {
      key = "claims_count";
    } else if (levelTwo === "Loss Ratio(Claim/Premium)") {
      key = "loss_ratio";
    } else if (levelTwo === "POSPm Count") {
      key = "count";
    } else if (levelTwo === "POSP Count") {
      key = "count";
    } else if (
      levelTwo === "Amount Disbursed" ||
      levelTwo === "Pending Claims"
    ) {
      key = "total";
    }
    if (viewData?.length) {
      const amountData: any = getAmountDisburse(viewData, "peril");
      const sortedArray =
        levelTwo === "Amount Disbursed" || levelTwo === "Pending Claims"
          ? sortListItems(amountData, key, TABLE_SORT_DESC)
          : sortListItems(viewData, key, TABLE_SORT_DESC);
      const topEight = sortedArray.filter((item)=>item.total !==0).slice(0, 7);      
      const labels: any[] = [];
      const dataTotal: number[] = [];
      const potential: number[] = [];
      if (levelTwo !== "Amount Disbursed" && levelTwo !== "Pending Claims") {
        topEight.forEach((element) => {
          if (levelOne === "POSPm") {
            labels.push(STATE_CODE_NAME[String(element?.sid)]?.code || NOT_AVAILABLE);
          } else {
            labels.push(
              `${STATE_CODE_NAME[String(String(element?.sid))]?.code || NOT_AVAILABLE},${element?.gridid}`
            );
          }
          dataTotal.push(element[key]);
        });
        const data = {
          labels: labels,
          datasets: [
            {
              axis: "y",
              data: dataTotal,
              backgroundColor:
                levelOne === "POSPm" ? ["#666CFF4D"] : ["#7C077C59"],
              borderWidth: 1,
              borderColor: levelOne === "POSPm" ? ["#666CFF"] : ["#883E88"],
              borderRadius: {
                topLeft: 4,
                topRight: 4,
                bottomRight: 4,
                bottomLeft: 4,
              },
            },
          ],
        };

        return {
          data,
          options: getGridChartOption(
            levelOne === "POSPm" ? "States" : "State, Grid Id",
            levelTwo === "Loss Ratio(Claim/Premium)"
              ? "Loss Ratio(Claims/Premium)"
              : levelTwo
          ),
          chartTitle: getTitle(levelTwo, "grid"),
        };
      } else {
        topEight.forEach((element) => {
          labels.push(element.id);
          dataTotal.push(element.processed);
          const data: any = (
            Number(element.total) - Number(element.processed)
          ).toFixed();
          potential.push(data);
        });

        const data = {
          labels: labels,
          datasets: [
            {
              label: "Amount Disbursed",
              data: dataTotal,
              backgroundColor: "#96D9FE",
              borderRadius: 4,
            },
            {
              label: "Potential",
              data: potential,
              backgroundColor: "#3498D1",
              borderRadius: 4,
            },
          ],
        };
        return {
          data,
          options: getAmountDisbursedOptions(levelTwo, "Perils"),
          chartTitle: getTitle(levelTwo, "grid"),
        };
      }
    }
  } catch (e) {}
  return null;
};

function centerSort(result) {
  const sorted = sortListItems(result, "total", TABLE_SORT_DESC);
  const newArray: any[] = [];
  sorted.forEach((item, index) => {
    if (index % 2 === 0) {
      newArray.unshift(item);
    } else {
      newArray.push(item);
    }
  });

  return newArray;
}

export const getCropData = (
  viewData: any,
  levelOne: string,
  levelTwo: string
) => {
  try {
    let result;
    if (levelTwo === "Policy Count") {
      result = getTotalValueWithKey(viewData, "crop_name", "Policy Count");
    } else if (levelTwo === "Premium") {
      result = getTotalValueWithKey(viewData, "crop_name", "Total Premium");
    } else if (levelTwo === "Insured Area") {
      result = getTotalValueWithKey(
        viewData,
        "crop_name",
        "Total Insured Area"
      );
    } else if (levelTwo === "Sum Insured") {
      result = getTotalValueWithKey(viewData, "crop_name", "Total Sum Insured");
    } else if (levelTwo === "Customer Count") {
      result = getCropWithPolicyCustomerCount(viewData);
    } else if (levelTwo === "Total Claim Count") {
      result = getTotalValueWithKey(viewData, "crop_name", "Total Claim Count");
    } else if (levelTwo === "Loss Ratio(Claim/Premium)") {
      result = getTotalValueWithKey(viewData, "crop_name", "Total Payout");
    } else if (levelTwo === "Amount Disbursed" || "Pending Claims") {
      result = getAmountDisburse(viewData, "crop_name");
    }

    if (result?.length) {
      let sortedArray = centerSort(result);

      const topEight = sortedArray.slice(0, 8);
      const labels: string[] = [];
      const dataTotal: number[] = [];
      topEight.forEach((element) => {
        labels.push(element.id);
        dataTotal.push(element.total);
      });
      const minVal = Math.min(...dataTotal);
      const maxVal = Math.max(...dataTotal);
      // const bubbleData = dataTotal.map((val, index) => {
      //   return {
      //     label: labels[index],
      //     data: [
      //       {
      //         x: index,
      //         y: val,
      //         r: Number(scaleRadius(val, minVal, maxVal).toFixed(2)),
      //       },
      //     ],
      //     backgroundColor: BUBBLE_CHART_COLOR[index],
      //     borderColor: "white",
      //     borderWidth: 1,
      //   };
      // });

      const xAxis = [60, 100, 160, 180, 270, 260, 360, 330];
      const yAxis = [110, 60, 120, 40, 40, 110, 60, 120, 60];
      const size = 8 - dataTotal?.length || 0;
      const bubbleData = dataTotal.map((val, index) => {
        return {
          label: getValueForMap(val),
          value: val,
          id: `bubble-${index}`,
          x: xAxis[index + size / 2],
          y: yAxis[index + size / 2],
          size: Number(scaleRadius(val, minVal, maxVal).toFixed(2)),
          color: BUBBLE_CHART_COLOR[index],
        };
      });
      const data = {
        datasets: bubbleData,
      };

      return {
        labels,
        dataTotal,
        data,
        options: CROP_CHART,
        chartTitle: getTitle(levelTwo, "crop"),
      };
    }
  } catch (e) {}
  return null;
};

export const getPerilData = (
  viewData: any,
  levelOne: string,
  levelTwo: string
) => {
  try {
    let result = getClaimCountPerilWise(viewData);
    if (result?.length) {
      const sortedArray = sortListItems(result, "total", TABLE_SORT_DESC);

      const labels: string[] = [];
      const dataTotal: number[] = [];
      sortedArray.forEach((element) => {
        labels.push(element.id);
        dataTotal.push(element.total);
      });
      const data = {
        labels: labels,
        datasets: [
          {
            label: "Total",
            data: dataTotal,
            backgroundColor: BUBBLE_CHART_COLOR,
            borderColor: "white",
            borderWidth: 1,
          },
        ],
      };

      return {
        data,
        options: PERIL_CHART,
        chartTitle: getTitle(levelTwo, "peril"),
      };
    }
  } catch (e) {}
  return null;
};
